import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  opened: boolean
}

export const AsideContainer: React.FC<Props> = ({ children, opened }) => (
  <div className={clsJoin(css.aside_container, opened && css.opened)}>
    {children}
  </div>
)
